import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import {
  getAllDepartments,
  getCollection,
  getCollectionList,
  getJourneyList,
  showProgress,
} from '../../../redux/actions/DealershipActions';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { ErrorToast } from '../../utils/Utils';
import service from '../../../apis/service';

const useCollection = () => {
  const dispatch = useDispatch();

  const fetchDepartments = useCallback(async () => {
    dispatch(showProgress(true));
    const res = await service.get(apiEndpoints.GET_DEPARTMENTS);
    dispatch(getAllDepartments(res));
    dispatch(showProgress(false));
  }, [dispatch]);

  const fetchJourneys = useCallback(async () => {
    dispatch(showProgress(true));
    const res = await service.get(apiEndpoints.GET_JOURNEYS);
    dispatch(getJourneyList('fetch', res));
    dispatch(showProgress(false));
  }, [dispatch]);

  const fetchCollection = async (id) => {
    dispatch(showProgress(true));
    try {
      const response = await service.get(apiEndpoints.COLLECTION_DETAIL.replace('ID', id));
      dispatch(getCollection('add', response));
    } catch (err) {
      ErrorToast(err);
    } finally {
      dispatch(showProgress(false));
    }
  };

  const fetchCollections = async () => {
    dispatch(showProgress(true));
    try {
      const response = await service.get(apiEndpoints.JOURNEY_COLLECTION_LIST);
      dispatch(getCollectionList('fetch', response, response[0]?.id));
      handleListItemClick(null, 0, response[0] ? response[0] : []);
    } catch (err) {
      ErrorToast(err);
    } finally {
      dispatch(showProgress(false));
    }
  };

  const handleListItemClick = (event, index, data) => {
    dispatch(getCollectionList('update_selectedId', {}, data.id));
    dispatch(getCollection('add', data));
    fetchCollection(data.id);
  };

  return {
    fetchCollection,
    fetchCollections,
    fetchJourneys,
    fetchDepartments,
    handleListItemClick,
  };
};
export default useCollection;
